"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const TextField_1 = __importDefault(require("@mui/material/TextField"));
const styled_components_1 = __importDefault(require("styled-components"));
const ErrorText_1 = __importDefault(require("../ErrorText"));
const StyledTextField = (0, styled_components_1.default)(TextField_1.default) `
  .MuiInputLabel-root {
    font-size: 16px;
  }

  .MuiOutlinedInput-notchedOutline {
    border-color: ${({ theme }) => theme.palette.gray[40]};
  }

  .Mui-focused .MuiOutlinedInput-notchedOutline {
    border-width: 1px;
  }

  input::placeholder {
    ${({ theme }) => theme.typography.variants.primary.small};
    color: ${({ theme }) => theme.palette.gray[60]};
    opacity: 1;
  }
`;
const EmailInput = ({ fieldProps, error, inputRef, ...rest }) => ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(StyledTextField, { ...fieldProps, InputLabelProps: {
                htmlFor: "email-address-input",
            }, autoComplete: "email", error: !!error, fullWidth: true, id: "email-address-input", inputProps: {
                "data-testid": "email-address",
            }, inputRef: inputRef, label: "Email address", type: "email", variant: "outlined", ...rest }), (0, jsx_runtime_1.jsx)(ErrorText_1.default, { message: "Oops! Enter a valid email address", show: !!error })] }));
exports.default = EmailInput;
//# sourceMappingURL=EmailInput.js.map